import { render } from "./EmsReleaseNotePopup.vue?vue&type=template&id=7b72eb5a&scoped=true&ts=true"
import script from "./EmsReleaseNotePopup.vue?vue&type=script&lang=ts"
export * from "./EmsReleaseNotePopup.vue?vue&type=script&lang=ts"

import "./EmsReleaseNotePopup.vue?vue&type=style&index=0&id=7b72eb5a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b72eb5a"]])

export default __exports__